//COmponents;
import React, { useState } from 'react';
import GalleryFrame from '../gallery-frame/GalleryFrame';

//Styles
import Styles from "../CommonGallery.module.scss";

//Constants
import { NaturePhotos } from "../../data/nature"
import { Categories } from '../../constants/categories';
import {
    BrowserRouter as Router,
    Link,
    useLocation
  } from "react-router-dom";

interface NatureProps {
    theme: string;
    category: string
    isEditing:boolean;
    onEditClick:()=>void;
}

const Nature = ({ theme, category,isEditing,onEditClick }: NatureProps) => {

    const query=useQuery()

    const [image, setImage] = useState(query.get("im_i") ?`../pi/l/Nature/n (${query.get("im_i")}).jpg` :`../images/placeholders/${category}.gif`)
    const [page,setPage]=useState(1)
    const pageLimit=Categories.NATURE.perPageLimit

    const handleImageClick = (url: string,index:number) => {
        setImage(url)
    }

    const handlePageClick=(pageNumber:number)=>{
        setPage(pageNumber)
    }

    const getPhotos = () => {
        return (<div className={Styles.gallery}>

            {NaturePhotos.slice(((page-1)*pageLimit),page*pageLimit).map((photo,index:number) => {
                return (
                    <div key={index} className={Styles.image} onClick={() => { handleImageClick(photo.imgUrl,index) }}>
                        <img src={photo.imgUrl} loading={"lazy"} />
                    </div>
                )
            })}

        </div>
        )
    }
    return (
        <div>
            <GalleryFrame
                mainImage={image}
                category={category}
                theme={theme}
                photosGallery={getPhotos()} 
                numberOfPages={NaturePhotos.length/pageLimit}
                currentPage={page}
                pageClick={handlePageClick}
                isEditing={isEditing}
                onEditClick={onEditClick}
                />
        </div>
    )
}
function useQuery() {
    const { search } = useLocation();
  
    return React.useMemo(() => new URLSearchParams(search), [search]);
  }
export default Nature
